import React from "react";
import LeadershipBlock from "../components/Leadership/LeadershipBlock";
export default function Leadership() {
    return (
        <section>
            <LeadershipBlock/>
        </section>



    );
}